import React from 'react';
import { Container, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Alert, Button, Grid, TextField, Typography } from '@mui/material';
//
import { HelpingDrawerLayout } from '/@/app/views/common/HelpingDrawerLayout';
import { messageStackState } from "/@/app/states/messageStackState";

//
import { TesterViewMenu } from '/@/app/views/TesterView/TesterViewMenu';

export const Style = () => {
    return (
        <HelpingDrawerLayout
            drawerContent={TesterViewMenu}
            buttonText="Разделы"
            // customized smaller sidebar
            sidebarWidth={{xs: "0", lg: "300px"}}
            drawerWidth={{xs: "100vw", sm: "300px"}}

        >
            <Container maxWidth="sm">
                <Box sx={{
                    pr: {xs: 2, sm: 0},
                    pb: 10,  // keep bottom space for floating bottom panels
                }}>
                    <StyleOverview />
                </Box>
            </Container>
        </HelpingDrawerLayout>
    );
}


const StyleOverview = () => {
    const theme = useTheme();
    const handleAddMessage = (tags) => {
        messageStackState.addMessage({
            text: 'New message ' + new Date().getTime(), tags: tags,
        });
    };

    const colors = ['info', 'warning', 'success', 'error'];


    return (
        <>
            <p>Основные элементы приложения, для отсмотра глазами:</p>
            <Box sx={{ '& > *': { m: 1 } }}>
                <Box>
                    <Typography variant="h5">Buttons</Typography>
                    <Typography variant="body1">Primary Color</Typography>
                    <Grid container spacing={2}>
                        <Grid item>
                            <Button variant="contained" color="primary">
                                Contained Primary
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button variant="outlined" color="primary">
                                Outlined Primary
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button variant="text" color="primary">
                                Text Primary
                            </Button>
                        </Grid>
                    </Grid>
                </Box>

                <Box>
                    <Typography variant="body1">Secondary Color</Typography>
                    <Grid container spacing={2}>
                        <Grid item>
                            <Button variant="contained" color="secondary">
                                Contained Secondary
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button variant="outlined" color="secondary">
                                Outlined Secondary
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button variant="text" color="secondary">
                                Text Secondary
                            </Button>
                        </Grid>
                    </Grid>
                </Box>

                <Box>
                    <Typography variant="h5" gutterBottom>Common text</Typography>
                    <Box>
                        <Typography variant="h6" gutterBottom>Nestarenie Link</Typography>
                        <Typography variant={"body1"}>
                            Some text, <a href="https://pubmed.ncbi.nlm.nih.gov/11148311" className="nestarenie-link" target="_blank">pubmed.ncbi.nlm.nih.gov/11148311</a>
                            some more text
                        </Typography>
                    </Box>

                    <Box>
                        <Typography variant="h6" gutterBottom>Nestarenie Biomarker</Typography>
                        <Typography variant={"body1"}>
                            Увеличенный общий риск смертности на 30% из-за повышенного
                            значения параметра <span className="nestarenie-biomarker">Частота
                            сердечных сокращений (ЧСС) в покое</span>, что эквивалентно
                            потере 2.5 лет жизни
                        </Typography>
                    </Box>
                </Box>

                <Box>
                    <Typography variant="h5" gutterBottom>Input fields</Typography>
                    <Grid container spacing={2}>
                        <Grid item>
                            <TextField label="Outlined no focus" color="" />
                        </Grid>
                        <Grid item>
                            <TextField label="Outlined primary" color="primary" focused />
                        </Grid>
                        <Grid item>
                            <TextField label="Outlined success" color="success" focused />
                        </Grid>
                        <Grid item>
                            <TextField label="Outlined secondary" color="secondary" focused />
                        </Grid>
                        <Grid item>
                            <TextField label="Outlined warning" color="warning" focused />
                        </Grid>
                        <Grid item>
                            <TextField label="Outlined error" color="error" focused error helperText="error text" />
                        </Grid>
                    </Grid>
                </Box>

                <Box>
                    <Typography variant="h5" gutterBottom>Alerts</Typography>
                    {/* Alerts for demonstrating error, warning, info, and success colors */}
                    <Grid container spacing={2}>
                        <Grid item>
                            <Alert severity="error">Error - This is an error alert</Alert>
                        </Grid>
                        <Grid item>
                            <Alert severity="warning">Warning - This is a warning alert</Alert>
                        </Grid>
                        <Grid item>
                            <Alert severity="info">Info - This is an info alert</Alert>
                        </Grid>
                        <Grid item>
                            <Alert severity="success">Success - This is a success alert</Alert>
                        </Grid>
                    </Grid>
                </Box>

                <Box>
                    <Typography variant="h5" gutterBottom>Messages</Typography>

                    <Button
                        variant="outlined"
                        onClick={() => (handleAddMessage('info'))}
                    >info</Button>
                    <Button
                        variant="outlined"
                        onClick={() => (handleAddMessage('warning'))}
                    >warning</Button>
                    <Button
                        variant="outlined"
                        onClick={() => (handleAddMessage('success'))}
                    >success</Button>
                    <Button
                        variant="outlined"
                        onClick={() => (handleAddMessage('error'))}
                    >error</Button>
                    <h3>Message colors</h3>
                    <Grid container spacing={1}>
                        {colors.map((color, index) => (
                            <Grid item key={index}>
                                <Box
                                    sx={{
                                        width: 30,
                                        height: 30,
                                        backgroundColor: theme.palette[color].main,
                                    }}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Box>
        </>
    );
}
